import { getPreSignedUrlForUpload } from '@/lib/api/services/storage.service';
import { ModuleName } from '@/constant/modules.constants';
import { DOCX_MIME } from '../components/docx-generate/utils';

const projectKey = import.meta.env.VITE_X_BLOCKS_KEY || '';

/**
 * Upload merged/edited .docx bytes to Blocks storage and return the public URL + fileId.
 *
 * Mirrors the two-step pattern the docx-builder uses to store tokenized templates
 * (GetPreSignedUrlForUpload → Azure Blob PUT). Used by the generate flow to persist the
 * merged .docx and by the review page to persist live text edits.
 */
export async function uploadDocxToStorage(
  bytes: Uint8Array | Blob,
  name: string
): Promise<{ url: string; fileId: string }> {
  const presigned = await getPreSignedUrlForUpload({
    name,
    projectKey,
    itemId: '',
    metaData: '',
    accessModifier: 'Public',
    configurationName: 'Default',
    parentDirectoryId: '',
    tags: '',
    moduleName: ModuleName.DefaultConstruct,
  });

  if (!presigned.isSuccess || !presigned.uploadUrl) {
    throw new Error('Failed to get upload URL from storage.');
  }

  const body =
    bytes instanceof Blob ? bytes : new Blob([bytes as BlobPart], { type: DOCX_MIME });

  await fetch(presigned.uploadUrl, {
    method: 'PUT',
    body,
    headers: {
      'Content-Type': DOCX_MIME,
      'x-ms-blob-type': 'BlockBlob',
    },
  });

  return { url: presigned.uploadUrl.split('?')[0], fileId: presigned.fileId || '' };
}
